import { jsx as e } from "react/jsx-runtime";
import { useEffect as n } from "react";
import a from "./index.es5585.js";
import { useCard as m } from "./index.es795.js";
import { LabelContainer as s } from "./index.es5586.js";
const i = ({ children: t }) => {
  const { registerContentId: o, contentId: r } = m();
  return n(() => {
    t && o();
  }, [t, o]), /* @__PURE__ */ e("div", { className: a["card--content"], "data-type": "card-content", id: r, children: t });
};
i.LabelsContainer = s;
export {
  i as CardContent
};
//# sourceMappingURL=index.es797.js.map
